<template>
    <div class="cq-home">
        <Header
            :isBack="!!$route.query.mode"
            backName="返回首页"
            :title="title"
        />
        <div class="container">
            <div class="left">
                <module
                    :moduleId="moduleList[0].moduleId"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[1].moduleId"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[2].moduleId"
                    :tradeSum="tradeSum"
                />
            </div>
            <div class="center">
                <trading-situation />
                <map-block />
            </div>
            <div class="right">
                <module
                    :moduleId="moduleList[3].moduleId"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[4].moduleId"
                    :tradeSum="tradeSum"
                />
                <module
                    :moduleId="moduleList[5].moduleId"
                    :tradeSum="tradeSum"
                />
            </div>
        </div>
    </div>
</template>

<script>
import * as fcScreenAPI from '@/api/fc-screen'
import Header from '@/components/Header'
import MapBlock from './blocks/MapBlock'
import Module from './blocks/module'
import TradingSituation from './blocks/TradingSituation'
import store from '@/utils/store'
import eventHub from '@/utils/eventHub'
import { STORE_AREA_INFO_KEY } from '@/constans/common'
export default {
    components: {
        Header,
        MapBlock,
        Module,
        TradingSituation
    },
    data() {
        return {
            title: '',
            moduleList: [
                {
                    moduleId: 1
                },
                {
                    moduleId: 3
                },
                {
                    moduleId: 2
                },
                {
                    moduleId: 8
                },
                {
                    moduleId: 9
                },
                {
                    moduleId: 10
                }
            ],
            tradeSum: {
                tdcbjyq: {
                    // 土地承包经营权
                    area: 0,
                    publishArea: 0,
                    transferArea: 0
                },
                jtzyxzc: {
                    // 集体资源性资产
                    area: 0,
                    publishArea: 0,
                    transferArea: 0
                },
                jtjyxzcq: {
                    // 集体经营性资产权
                    FW_area: 0,
                    FW_publish_area: 0,
                    FW_sumAreas: 0,
                    JQSB_permission: 0,
                    JQSB_publish: 0,
                    JQSB_transfer: 0,
                    QT_permission: '',
                    QT_publish: 0,
                    QT_transfer: 0
                }
            }
        }
    },
    watch: {
        $route: {
            handler: function(route) {
                const query = route.query
                if (!query.backId) {
                    sessionStorage.removeItem('list')
                }
            },
            immediate: true
        }
    },
    methods: {
        async getSummary(cId) {
            const p1 = {
                locCounty: 1565,
                locTown: cId,
                type: 'land'
            }
            const p2 = {
                locCounty: 1565,
                locTown: cId,
                type: 'business'
            }
            const p3 = {
                locCounty: 1565,
                locTown: cId
            }
            const tdcbjyq = await fcScreenAPI.tradeAmountSummary(p1)
            const jtzyxzc = await fcScreenAPI.tradeAmountSummary(p2)
            const jtjyxzcq = await fcScreenAPI.collectiveAssets(p3)
            this.tradeSum = {
                tdcbjyq: tdcbjyq.data || this.tradeSum.tdcbjyq,
                jtzyxzc: jtzyxzc.data || this.tradeSum.jtzyxzc,
                jtjyxzcq: jtjyxzcq.data || this.tradeSum.jtjyxzcq
            }
            eventHub.$emit('tradeChange', this.tradeSum)
        }
    },
    mounted() {
        /**
         * 存储当前地区 id
         * 并触发地区改变时间
         */
        store.setValue(STORE_AREA_INFO_KEY, {
            tuLiuLocId: '1565'
        })

        this.getSummary()
        eventHub.$emit('areaChange')

        /**
         * 监听标题改变事件
         */
        eventHub.$on('titleChange', (title) => {
            document.title = this.title = `${title}农村产权交易大数据`
            store.setValue(STORE_AREA_INFO_KEY, {
                documentTitle: this.title
            })
        })
        eventHub.$on('areaChange', (cId) => {
            this.getSummary(cId)
        })
    }
}
</script>

<style lang="scss" scoped>
.table-info,
.solid-box,
.echarts-block {
    width: 620px !important;
}
.cq-home {
    flex-flow: column;
    padding: 0 !important;
    .container {
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        box-sizing: border-box;
        padding: 13px 15px 11px 15px;
        > .left,
        > .right,
        > .center {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }
}
</style>
